import { Link } from 'react-router-dom';
import { Mail, Linkedin, Facebook, Twitter } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      { name: 'Monthly Marketing', path: '/monthly-marketing' },
      { name: 'Marketing Strategy', path: '/marketing-strategy' },
      { name: 'Digital Marketing', path: '/digital-marketing' },
      { name: 'MSP Marketing', path: '/unite-nation-tech' }
    ],
    company: [
      { name: 'About Us', path: '/about' },
      { name: 'Blog', path: '/blog' },
      { name: 'Contact', path: '/contact' }
    ]
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-1">
            <div className="text-2xl font-bold mb-4">
              <span className="text-white">Unite</span>
              <span className="text-[#FBD116]"> Marketing</span>
            </div>
            <p className="text-sm mb-4">
              A marketing agency on a mission to Unite with businesses to help them be consistent, strategic, and innovative.
            </p>
            <div className="flex space-x-3">
              <a
                href="mailto:bronny@mpremarketing.com"
                className="w-10 h-10 rounded-full bg-gray-800 hover:bg-[#FBD116] flex items-center justify-center transition-colors group"
              >
                <Mail className="w-5 h-5 text-gray-300 group-hover:text-gray-900" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-gray-800 hover:bg-[#FBD116] flex items-center justify-center transition-colors group"
              >
                <Linkedin className="w-5 h-5 text-gray-300 group-hover:text-gray-900" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-gray-800 hover:bg-[#FBD116] flex items-center justify-center transition-colors group"
              >
                <Facebook className="w-5 h-5 text-gray-300 group-hover:text-gray-900" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-gray-800 hover:bg-[#FBD116] flex items-center justify-center transition-colors group"
              >
                <Twitter className="w-5 h-5 text-gray-300 group-hover:text-gray-900" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              {footerLinks.services.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm hover:text-[#FBD116] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm hover:text-[#FBD116] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Get Started</h3>
            <p className="text-sm mb-4">
              Book a no-obligation chat or free marketing audit.
            </p>
            <a
              href="https://calendly.com/bronny-mpremarketing/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-6 py-2 bg-[#FBD116] hover:bg-[#E5C015] text-gray-900 font-semibold rounded-lg transition-colors"
            >
              Book a Call
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm">
            <p>&copy; {currentYear} Unite Marketing. All rights reserved.</p>
            <p className="mt-2 md:mt-0">
              Based in New Zealand | 100% Remote
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
